import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "./FeaturedProducts.css";

const products = [
  {
    title: "RemeCure Scar C-section",
    img: "./assets/C-section.webp",
    tag: "Derma, Silicone Sheets",
    tagColor: "#510c76",
  },
  {
    title: "RemeCure Scar",
    img: "./assets/RemeCure-Scar.webp",
    tag: "Derma, Silicone Sheets",
    tagColor: "#f6924e",
  },
  {
    title: "RemeCure Scar Acne/Face",
    img: "./assets/AcneFace.webp",
    tag: "Derma, Silicone Sheets",
    tagColor: "#25a1ba",
  },
  {
    title: "RemeCure Scar Acne/Face",
    img: "./assets/Augmaplexy.webp",
    tag: "Derma, Silicone Sheets",
    tagColor: "#ae438e",
  },
  {
    title: "RemeCure Scar Acne/Face",
    img: "./assets/Tummy-Tuck.webp",
    tag: "Derma, Silicone Sheets",
    tagColor: "#3e9261",
  },
];

const FeaturedProducts = () => {
  return (
    <section className="featured-section">
      <h2 className="section-title">Featured Products</h2>
      <div className="container">
        <div className="slider-container">
          <Swiper
            modules={[Navigation]}
            navigation={true}
            spaceBetween={24}
            slidesPerView={3}
            loop={true}
            breakpoints={{
              320: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1200: { slidesPerView: 3 },
            }}
          >
            {products.map((product, index) => (
              <SwiperSlide key={index}>
                <div className="product-card">
                  <div
                    className="product-tag"
                    style={{
                      backgroundColor: product.tagColor.startsWith("#")
                        ? product.tagColor
                        : undefined,
                    }}
                  >
                    {product.tag}
                  </div>
                  <img
                    src={product.img}
                    alt={product.title}
                    className="product-img"
                  />
                </div>
                <h3 className="product-title">{product.title}</h3>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
